const propsEvent = {
    onAbort: true,
    onAbortCapture: true,
    onAnimationEnd: true,
    onAnimationEndCapture: true,
    onAnimationIteration: true,
    onAnimationIterationCapture: true,
    onAnimationStart: true,
    onAnimationStartCapture: true,
    onBlur: true,
    onBlurCapture: true,
    onCanPlay: true,
    onCanPlayCapture: true,
    onCanPlayThrough: true,
    onCanPlayThroughCapture: true,
    onChange: true,
    onChangeCapture: true,
    onClick: true,
    onClickCapture: true,
    onCompositionEnd: true,
    onCompositionEndCapture: true,
    onCompositionStart: true,
    onCompositionStartCapture: true,
    onCompositionUpdate: true,
    onCompositionUpdateCapture: true,
    onContextMenu: true,
    onContextMenuCapture: true,
    onCopy: true,
    onCopyCapture: true,
    onCut: true,
    onCutCapture: true,
    onDoubleClick: true,
    onDoubleClickCapture: true,
    onDrag: true,
    onDragCapture: true,
    onDragEnd: true,
    onDragEndCapture: true,
    onDragEnter: true,
    onDragEnterCapture: true,
    onDragExit: true,
    onDragExitCapture: true,
    onDragLeave: true,
    onDragLeaveCapture: true,
    onDragOver: true,
    onDragOverCapture: true,
    onDragStart: true,
    onDragStartCapture: true,
    onDrop: true,
    onDropCapture: true,
    onDurationChange: true,
    onDurationChangeCapture: true,
    onEmptied: true,
    onEmptiedCapture: true,
    onEncrypted: true,
    onEncryptedCapture: true,
    onEnded: true,
    onEndedCapture: true,
    onError: true,
    onErrorCapture: true,
    onFocus: true,
    onFocusCapture: true,
    onGotPointerCapture: true,
    onInput: true,
    onInputCapture: true,
    onInvalid: true,
    onInvalidCapture: true,
    onKeyDown: true,
    onKeyDownCapture: true,
    onKeyPress: true,
    onKeyPressCapture: true,
    onKeyUp: true,
    onKeyUpCapture: true,
    onLoad: true,
    onLoadCapture: true,
    onLoadStart: true,
    onLoadStartCapture: true,
    onLoadedData: true,
    onLoadedDataCapture: true,
    onLoadedMetadata: true,
    onLostPointerCapture: true,
    onMouseDown: true,
    onMouseDownCapture: true,
    onMouseEnter: true,
    onMouseEnterCapture: true,
    onMouseLeave: true,
    onMouseLeaveCapture: true,
    onMouseMove: true,
    onMouseMoveCapture: true,
    onMouseOut: true,
    onMouseOutCapture: true,
    onMouseOver: true,
    onMouseOverCapture: true,
    onMouseUp: true,
    onMouseUpCapture: true,
    onPaste: true,
    onPasteCapture: true,
    onPause: true,
    onPauseCapture: true,
    onPlay: true,
    onPlayCapture: true,
    onPlaying: true,
    onPlayingCapture: true,
    onPointerCancel: true,
    onPointerCancelCapture: true,
    onPointerDown: true,
    onPointerDownCapture: true,
    onPointerEnter: true,
    onPointerLeave: true,
    onPointerMove: true,
    onPointerMoveCapture: true,
    onPointerOut: true,
    onPointerOutCapture: true,
    onPointerOver: true,
    onPointerOverCapture: true,
    onPointerUp: true,
    onPointerUpCapture: true,
    onProgress: true,
    onProgressCapture: true,
    onRateChange: true,
    onRateChangeCapture: true,
    onReset: true,
    onResetCapture: true,
    onScroll: true,
    onScrollCapture: true,
    onSeeked: true,
    onSeekedCapture: true,
    onSeeking: true,
    onSeekingCapture: true,
    onSelect: true,
    onSelectCapture: true,
    onStalled: true,
    onStalledCapture: true,
    onSubmit: true,
    onSubmitCapture: true,
    onSuspend: true,
    onSuspendCapture: true,
    onTimeUpdate: true,
    onTimeUpdateCapture: true,
    onToggle: true,
    onToggleCapture: true,
    onTouchCancel: true,
    onTouchCancelCapture: true,
    onTouchEnd: true,
    onTouchEndCapture: true,
    onTouchMove: true,
    onTouchMoveCapture: true,
    onTouchStart: true,
    onTouchStartCapture: true,
    onTransitionEnd: true,
    onTransitionEndCapture: true,
    onVolumeChange: true,
    onVolumeChangeCapture: true,
    onWaiting: true,
    onWaitingCapture: true,
    onWheel: true,
    onWheelCapture: true
};

export default propsEvent;
